import React from 'react';
import styles from './TopBar8.module.css';
import { FaFacebookF, FaInstagram, FaTwitter, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import { useAuth } from '../../Common/Configurations/AuthContext';

const TopBar8 = ({ branding }) => {
  const { user } = useAuth();

  const phone =
    branding?.phones?.join(" | ") ||
    user?.companyPhone ||
    "+91 0000000000";

  const email =
    branding?.email ||
    user?.companyEmail ||
    "contact@travel.com";

  const facebookUrl =
    branding?.socials?.facebook || "#";

  const instagramUrl =
    branding?.socials?.instagram || "#";

  const twitterUrl =
    branding?.socials?.x || "#";

  return (
    <div className={styles.topBar}>
      <div className={styles.gridContainer}>
        
        {/* Module 1: Brand Status */}
        <div className={styles.module}>
          <div className={styles.statusPulse}></div>
          <span className={styles.statusText}>Live Support</span>
        </div>

        {/* Module 2: Phone */}
        <div className={styles.module}>
          <FaPhoneAlt className={styles.gridIcon} />
          <span className={styles.dataValue}>{phone}</span>
        </div>

        {/* Module 3: Email */}
        <div className={styles.module}>
          <FaEnvelope className={styles.gridIcon} />
          <span className={styles.dataValue}>{email}</span>
        </div>

        {/* Module 4: Social Links */}
        <div className={styles.socialModule}>
          
          <a href={facebookUrl} target="_blank" rel="noreferrer" className={styles.gridSocialLink}>
            <span className={styles.index}>01</span>
            <FaFacebookF />
          </a>

          <a href={instagramUrl} target="_blank" rel="noreferrer" className={styles.gridSocialLink}>
            <span className={styles.index}>02</span>
            <FaInstagram />
          </a>

          <a href={twitterUrl} target="_blank" rel="noreferrer" className={styles.gridSocialLink}>
            <span className={styles.index}>03</span>
            <FaTwitter />
          </a>

        </div>

      </div>
    </div>
  );
};

export default TopBar8;